export interface FilterStatus {
  statuses: number[];
  type: number;
}

export interface FilterPriority {
  priorities: number[];
  type: number;
}

export interface FilterAssign {
  assignees: string[];
  type: number;
}

export interface FilterDueDate {
  date: string[];
  type: number;
  startDate?: string;
  endDate?: string;
}

export interface FilterProject {
  projects: string[];
  type: number;
}

export interface FilterCustomer {
  customers: string[];
  type: number;
}

export interface ViewFilters {
  status: FilterStatus;
  priority: FilterPriority;
  assign: FilterAssign;
  dueDate: FilterDueDate;
  project: FilterProject;
  customer: FilterCustomer;
}

export interface RawView {
  // Common
  id: string;
  name: string;
  description: string;
  icon: Icon;
  color: number;
  userIds: string[];

  //Default fields
  createdById: string;
  createdOn: Date;
  updatedById: string;
  updatedOn: Date;

  filters: ViewFilters;
  isReadOnly: boolean;
}

export interface Icon {
  type: number;
  color: number;
  reference: string;
}

export const VIEWS_FILTER_TYPE = {
  IS: 1,
  IS_NOT: 2,
  AFTER: 3,
  BEFORE: 4,
  RANGE: 5
};

export const VIEW_FILTER_LABELS = {
  [VIEWS_FILTER_TYPE.IS]: 'is',
  [VIEWS_FILTER_TYPE.IS_NOT]: 'is not',
  [VIEWS_FILTER_TYPE.AFTER]: 'after',
  [VIEWS_FILTER_TYPE.BEFORE]: 'before',
  [VIEWS_FILTER_TYPE.RANGE]: 'between'
};

export const DEFAULT_VIEW_FILTERS = {
  status: {
    statuses: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  priority: {
    priorities: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  assign: {
    assignees: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  dueDate: {
    date: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  project: {
    projects: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  customer: {
    customers: [],
    type: VIEWS_FILTER_TYPE.IS
  }
};

// Payload type for creating a new View via service/API
export interface CreateViewPayload {
  id: string;
  name: string;
  description: string;
  icon: Icon;
  color?: number;
  userIds?: string[];
  filters: ViewFilters;
}

// Payload type for updating a View via service/API
export type UpdateViewPayload = CreateViewPayload;

// Payload type for adding/removing users to/from a view via service/API
export interface UpdateViewUsersPayload {
  users: (string | undefined)[] | undefined;
}
